import * as React from "react";
import { SVGProps } from "react";
export function MemberTypeGraduateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={29}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={1.083}
        y={0.583}
        width={26.833}
        height={26.833}
        rx={13.417}
        fill="#F4BF43"
      />
      <rect
        x={1.083}
        y={0.583}
        width={26.833}
        height={26.833}
        rx={13.417}
        stroke="#F4BF43"
        strokeWidth={1.167}
      />
      <g
        clipPath="url(#member-type-graduate_svg__a)"
        stroke="#fff"
        strokeWidth={1.167}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m14.505 7.428 7.583 3.286L14.505 14l-7.583-3.286 7.583-3.286Z" />
        <path d="m10.36 12.213.007 3.575s1.252 1.657 4.135 1.657c2.882 0 4.141-1.657 4.141-1.657v-3.575M8.313 18.201v-6.872M8.317 20.992a1.395 1.395 0 1 0 0-2.79 1.395 1.395 0 0 0 0 2.79Z" />
      </g>
      <defs>
        <clipPath id="member-type-graduate_svg__a">
          <path
            fill="#fff"
            transform="translate(6.336 5.833)"
            d="M0 0h16.333v16.333H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
